import { render } from "./ButtonEditorCmp.vue?vue&type=template&id=08baf9c6&scoped=true"
import script from "./ButtonEditorCmp.vue?vue&type=script&lang=js"
export * from "./ButtonEditorCmp.vue?vue&type=script&lang=js"

import "./ButtonEditorCmp.vue?vue&type=style&index=0&id=08baf9c6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08baf9c6"]])

export default __exports__